<template>
    <!--    <div class="columns_content">-->
    <!--        <p style="font-weight: 400; font-size: 1.3rem; line-height: 1.5rem;color: var(&#45;&#45;cdl-black);padding-left: 2rem;">-->
    <!--            {{ poll.poll_languages[0].pivot.title }}</p>-->
    <!--        <div v-if="expiredPoll">-->
    <!--            <div v-for="pollOption in poll.poll_options">-->
    <!--                <button class="poll_btn not-selected">-->
    <!--                    {{ pollOption.poll_option_languages[0].pivot.title }}-->
    <!--                </button>-->
    <!--            </div>-->
    <!--        </div>-->

    <!--        <div v-else>-->
    <!--            <div v-for="pollOption in poll.poll_options" v-if="!loading">-->
    <!--                <a :href="$store.state.hrefPrefix + '/account/login'" v-if="$store.state.user.id == null">-->
    <!--                    <button v-if="!loading" class="poll_btn">-->
    <!--                        {{ pollOption.poll_option_languages[0].pivot.title }}-->
    <!--                    </button>-->
    <!--                </a>-->
    <!--                <button v-else @click="submitPoll(poll.id, pollOption.id)" class="poll_btn"-->
<!--                            :class="{'selected': poll.submitted_option && poll.submitted_option.id === pollOption.id,-->
<!--                                                     'not-selected': poll.submitted_option && poll.submitted_option.id !== pollOption.id,-->
<!--                                                     'hidden': loading }">-->
    <!--                    {{ pollOption.poll_option_languages[0].pivot.title }}-->
    <!--                    {{ pollOption.vote_percentage }} %-->
    <!--                </button>-->
    <!--            </div>-->
    <!--            <div class="loading" v-else>Loading...</div>-->
    <!--        </div>-->


    <!--            <div>-->
    <!--                <p style="float: right; margin-top: 23px; font-weight: 600;font-size: 0.875rem;display: block;color: var(&#45;&#45;cdl-secondary);">-->
    <!--                    <span>{{ poll.total_votes }} vote, </span>-->
    <!--                    <span v-if="expiredPoll" style="color:var(&#45;&#45;cdl-primary)">Expired</span>-->
    <!--                    <span v-else>{{ daysAndHoursLeft(poll.end_date) }}</span>-->

    <!--                </p>-->
    <!--            </div>-->
    <!--        </div>-->

    <div class="poll-card">
        <div class="question">
            {{ poll.poll_languages[0].pivot.title }}
        </div>
        <div class="options" v-if="expiredPoll">
            <div class="option" style="position: relative" v-for="pollOption in pollData.poll_options">
                <div
                     :style="{width: `${pollOption.vote_percentage}%`}"
                     style="position: absolute; left: 0; top: 0;   background-color: gray; height: 100%; z-index: 0"></div>
                <div class="analytic" style="position: relative; z-index: 1; width: 100%">
                    <!--                    <div class="bar"></div>-->
                    <div class="percent"> {{ pollOption.vote_percentage }} %</div>
                </div>
                <div class="input" style="position: relative; z-index: 1">
                    <input type="submit" :id="'option-' + pollOption.id" name="option" hidden>
                    <label  :for="'option-' + pollOption.id">
                        {{ pollOption.poll_option_languages[0].pivot.title }}
                    </label>
                </div>

            </div>
            <div>
                <p style="float: right; margin-top: 23px; font-weight: 600;font-size: 0.875rem;display: block;color: var(--cdl-secondary);">
                    <span>{{ poll.total_votes }} vote, </span>
                    <span style="color:var(--cdl-primary)">Expired</span>

                </p>
            </div>

        </div>

        <div class="options" v-else>
            <div class="option" style="position: relative" v-for="pollOption in pollData.poll_options" v-if="!loading">
                <div :style="{width: `${pollOption.vote_percentage}%`}"  :class="{'selected': pollData.submitted_option && pollData.submitted_option.id === pollOption.id,
                                     'not-selected': pollData.submitted_option && pollData.submitted_option.id !== pollOption.id,
                                      'hidden': loading }"></div>
                <div class="analytic" style="position: relative; z-index: 1; width: 100%">
                    <!--                    <div class="bar"></div>-->
                    <div class="percent" v-if="pollData.submitted_option"> {{ pollOption.vote_percentage }} %</div>
                </div>
                <div class="input" style="position: relative; z-index: 1" v-if="$store.state.user.id == null">
                    <a style="color: #191919" :href="$store.state.hrefPrefix + '/account/login'" >
                        <input type="submit" :id="'option-' + pollOption.id" name="option" hidden
                               @click="submitPoll(poll.id, pollOption.id)">
                        <label :for="'option-' + pollOption.id">
                            {{ pollOption.poll_option_languages[0].pivot.title }}
                        </label>
                    </a>

                </div>


                <div class="input" style="position: relative; z-index: 1" v-else>
                    <input type="submit" :id="'option-' + pollOption.id" name="option" hidden
                           @click="submitPoll(poll.id, pollOption.id)" >
                    <label :for="'option-' + pollOption.id">
                        {{ pollOption.poll_option_languages[0].pivot.title }}
                    </label>
                </div>

            </div>
                        <div class="loading" v-else>Loading...</div>
            <div>
                <p style="float: right; margin-top: 23px; font-weight: 600;font-size: 0.875rem;display: block;color: var(--cdl-secondary);">
                    <span>{{ pollData.total_votes }} vote, </span>
                    <span >{{ daysAndHoursLeft(poll.end_date) }}</span>

                </p>
            </div>

        </div>
    </div>
</template>

<script>
import index from "vuex";

export default {
    name: "Poll",
    props: {
        poll: {
            default: null
        },
    },
    data() {
        return {
            loading:false,
            pollData: this.poll,
        }
    },
    methods: {
        // calculateTotalScore() {
        //     let totalScore = 0;
        //     if (this.poll && this.poll.poll_options) {
        //         this.poll.poll_options.forEach(pollOption => {
        //             totalScore += pollOption.score;
        //         });
        //
        //     }
        //     return totalScore;
        // },
        daysAndHoursLeft(endDate) {
            const endDateObject = new Date(endDate);
            const currentDate = new Date();

            const timeDifference = endDateObject.getTime() - currentDate.getTime();

            const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
            const hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));

            return `${days} days and ${hours} hours left`;
        },

        submitPoll(pollId, pollOptionId) {
            this.loading = true
            if (this.poll.submitted_option != null) {
                return
            }
            console.log(pollOptionId)
            axios.post("/api/poll", {
                poll_id: pollId,
                poll_option_id: pollOptionId
            }).then((response) => {
                this.loading = false
                this.pollData = response.data
                this.$forceUpdate();
                    // const selectedOption = this.poll.poll_options.find(option => option.id === pollOptionId);
                    // this.poll.submitted_option = selectedOption;
                    // if (selectedOption) {
                    //     this.pollData = response.data
                    //     this.$forceUpdate();
                    // }
                }).catch((error) => {
                    this.loading = false;
                    console.error(error);
                });
        },
    },
    computed: {
        expiredPoll() {
            const endDate = new Date(this.poll.end_date);
            const currentDate = new Date();
            return endDate < currentDate;
        }
    },
}
</script>

<style scoped>

.poll-card {
    width: 100%;
    padding: 1rem 1.5rem;
}

.question {
    font-weight: 700;
    margin-bottom: 1rem;
}

.option {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0.4rem 0;
    border: 1px solid #c9c9c9;
    border-radius: 4px;
    position: relative;
}



.input {
    width: 100%;
}

label {
    display: block;
    cursor: pointer;
    padding: 0.8rem;
}

.percent {
    position: absolute;
    right: 7px;
    top: 12px;
    font-weight: 700;
}



.selected {
    position: absolute;
    left: 0;
    top: 0;
    background-color: var(--cdl-primary);
    height: 100%;
    z-index: 0
}

.not-selected {
    background-color: #e9e9e9;
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    z-index: 0

}

.loading {
    margin-top: 5px;
    width: 100%;
    margin-left: 2rem;
    height: 40px;
    color: var(--cdl-primary);
    font-size: 1rem;
    font-weight: 700;
    appearance: none;
    border: 1px var(--cdl-light) solid;
}
</style>
